import { Grid, Radio, RadioGroup, Typography } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import useAPI from "../../../../../../api/hooks/useAPI";
import useColors from "../../../../../../api/hooks/useColors";
import { notificationSettingsKeys } from "../../../../../../api/queryKeys";
import { operationStatus } from "../../../../../../components/ActionStatus";
import { field_IDs_mapping } from "../../../fieldMapping";
import { ALL_OPTIONS } from "./DaySelector";
import { frequencyType } from "./FrequencyNotificationsSection";

export default function FrequencyTypeSelector({
  method,
  setFetchStatus,
  selectedFrequencyType,
  setSelectedFrequencyType,
}) {
  const colors = useColors();
  const [disabledCheckboxes, setDisabledCheckboxes] = useState(false);

  const { updateNotificationSetting } = useAPI();
  const queryClient = useQueryClient();

  const frequencies = [
    ["Daily", frequencyType.DAILY],
    ["Weekly", frequencyType.WEEKLY],
  ];

  const handleChange = async (newValue) => {
    const currentValue = selectedFrequencyType;
    setSelectedFrequencyType(newValue);
    setFetchStatus(operationStatus.LOADING);
    setDisabledCheckboxes(true);

    try {
      await updateNotificationSetting(
        method,
        field_IDs_mapping.FREQUENCY.FREQUENCY_TYPE,
        newValue
      );
      // If the frequency type is changed to weekly, the selected days should be reset to only one
      if (newValue === frequencyType.WEEKLY) {
        await updateNotificationSetting(
          method,
          field_IDs_mapping.FREQUENCY.DAYS,
          [ALL_OPTIONS[0]]
        );
      }
      setFetchStatus(operationStatus.SUCCESS);
      queryClient.invalidateQueries({
        queryKey: notificationSettingsKeys.all,
      });
    } catch (error) {
      setFetchStatus(operationStatus.ERROR);
      setSelectedFrequencyType(currentValue);
    }

    setDisabledCheckboxes(false);
  };

  return (
    <RadioGroup>
      <Grid container direction="row" gap={4}>
        {frequencies.map(([label, value]) => (
          <Grid item key={label}>
            <Grid container direction="row" gap={2}>
              <Grid item>
                <Radio
                  value={value}
                  checked={selectedFrequencyType === value}
                  onChange={() => handleChange(value)}
                  disabled={disabledCheckboxes}
                  sx={{
                    width: "16px",
                    height: "16px",
                    "& .MuiSvgIcon-root": { fontSize: "1rem" },
                    "&.Mui-checked": {
                      color: colors.primary_main,
                    },
                    display: "flex",
                    alignItems: "center",
                  }}
                />
              </Grid>
              <Grid item>
                <Typography variant="body2">{label}</Typography>
              </Grid>
            </Grid>
          </Grid>
        ))}
      </Grid>
    </RadioGroup>
  );
}
